import { ChemicalComponent } from "@/services/chemical-component"
import { LeftOutlined, RightOutlined } from "@ant-design/icons"
import { Button, Col, Input, Row, Table } from "antd"
import Title from "antd/es/typography/Title"
import { useEffect, useMemo, useState } from "react"
import styles from './index.module.less';

interface TableTransferProps {
  dataSource: ChemicalComponent.Base[];
  onChange: (keys: number[]) => void;
  value: number[]
}

export const ComponentsTransfer: React.FC<TableTransferProps> = (props) => {
  const {dataSource, onChange, value} = props
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [leftData, setLeftData] = useState<ChemicalComponent.Base[]>([])
  const [rightData, setRightData] = useState<ChemicalComponent.Base[]>(dataSource)
  const [leftSelectedKeys, setLeftSelectedKeys] = useState<React.Key[]>([]);
  const [text, setText] = useState('')

  useEffect(() => {
    setRightData(dataSource)
  }, [dataSource])

  useEffect(() => {
    const left = dataSource.filter(item => value.includes(item.id))
    const right = dataSource.filter(item => !value.includes(item.id))
    setLeftData(left)
    setRightData(right)
    setLeftSelectedKeys([])
    setSelectedRowKeys([])
  }, [dataSource, value])

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Formula',
      dataIndex: 'formula',
      key: 'formula',
    },
  ]

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const onLeftSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setLeftSelectedKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const leftSelection = {
    selectedRowKeys: leftSelectedKeys,
    onChange: onLeftSelectChange,
  }

  const hasSelected = selectedRowKeys.length > 0;

  const onAdd = () => {
    const news = selectedRowKeys.filter(id => {
      return !leftData.find(item => item.id === id)
    }) as number[]
    const newLeft = [...value, ...news]
    onChange(newLeft)
  }

  const onRemove = (keys: number[]) => {
    const newVal = value.filter(item => !keys.includes(item))
    onChange(newVal)
  }

  const onFilter = (text: string) => {
    setText(text)
  }

  const filteredRightData = useMemo(() => {
    return rightData.filter(item => {
      const searchText = text.toLowerCase()
      return item.name.toLowerCase().includes(searchText) || item.formula.toLowerCase().includes(searchText)
    })
  }, [rightData, text])


  return (
    <Row gutter={24} style={{minWidth: 800}}>
      <Col span={10}>
        <Title level={4}>Property Set Components</Title>
        <div className={styles.tableContainer}>
          <Table
            bordered
            pagination={{ pageSize: 50, hideOnSinglePage: true }}
            rowSelection={leftSelection}
            size='small'
            rowKey={'id'}
            columns={[...columns, {
              title: 'Actions',
              key: 'actions',
              render: (_, record) => {
                return <Button size="small" onClick={() => {
                  onRemove([record.id])
                }}>Delete</Button>
              }
            }]}
            dataSource={leftData}
          />
        </div>
      </Col>
      <Col span={4} style={{display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
        <div><Button style={{width: 100}} disabled={!hasSelected} type="primary" icon={<LeftOutlined />} onClick={onAdd}>Add</Button></div>
        <div className="mt-2"><Button
        disabled={leftSelectedKeys.length === 0}
        onClick={() => {
          onRemove(leftSelectedKeys as number[])
        }} style={{width: 100}} type="default" icon={<RightOutlined />} iconPosition="end">Remove</Button></div>
      </Col>
      <Col span={10}>
        <Title level={4}>Components</Title>
        <div className={styles.tableContainer}>
          <div>
            <Input placeholder="Search by name or formula" onChange={(e) => onFilter(e.target.value)} />
          </div>
          <Table
            className="mt-1"
            bordered
            pagination={{ pageSize: 50, hideOnSinglePage: true }}
            size='small'
            rowKey={'id'}
            columns={columns}
            dataSource={filteredRightData}
            rowSelection={rowSelection}
          />
        </div>
      </Col>
    </Row>
  );
};